/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from "react";
import classNames from "classnames";
import { Field, reduxForm, formValueSelector, change as changeFieldValue } from "redux-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { errorMessage } from "../Shared/ReduxFormInputs";
import { CheckboxField } from "../Shared/ReduxFormInputs/checkbox-field";
import { TextField } from "../Shared/ReduxFormInputs/text-field";

class NewsletterSignupBannerForm extends Component {
    render() {
        const ctaBackgroundColorClass = this.props.CtaBackgroundColorClass;
        const ctaTextColorClass = this.props.CtaTextColorClass;
        const parentClass = "newsletter-banner";
        const sumbitButtonClasses = classNames(
            `${parentClass}__submit-button`,
            { [`${ctaBackgroundColorClass}--bg`]: ctaBackgroundColorClass },
            { [`${ctaTextColorClass}--text`]: ctaTextColorClass }
        );

        return (
            <form onSubmit={this.props.handleSubmit} className={`${parentClass}__form`}>
                <div className="content-row">
                    <div className="content-column--large-50 content-column--gutter--large">
                        <Field name="name" component={TextField} label={this.props.NameText} required />
                    </div>
                    <div className="content-column--large-50 content-column--gutter--large">
                        <Field name="email" component={TextField} label={this.props.EmailText} required />
                    </div>
                </div>
                <div className="content-row">
                    <div className="content-column--medium-50 content-column--large-66 content-column--gutter--large">
                        <div className={`form-terms ${parentClass}__form__terms`}>
                            <Field id="bannerPermission" name="permission" component={CheckboxField} />
                            <label
                                htmlFor="bannerPermission"
                                className="form-terms__text content-rich-text"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        this.props.AgreementCheckboxText +
                                        `<span class="required-star">*</span>`
                                }}
                            />
                            <Field name="permission" component={errorMessage} />
                        </div>
                    </div>
                    <div className="content-column--medium-50 content-column--large-33 content-column--gutter--large">
                        <button
                            className={sumbitButtonClasses}
                            type="submit"
                            disabled={this.props.newsletterSignupPending}
                        >
                            {this.props.newsletterSignupPending ? (
                                <span className="loader button-is-loading">
                                    <span></span>
                                </span>
                            ) : (
                                <span>{this.props.SignupButtonText}</span>
                            )}
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ changeFieldValue }, dispatch);
}

function mapStateToProps(state) {
    return {
        email: selector(state, "email")
    };
}

const selector = formValueSelector("newsletterSignupBannerForm");

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: "newsletterSignupBannerForm"
    })(NewsletterSignupBannerForm)
);
